import Flux from 'Flux';

export default new Flux.Dispatcher();


// WEBPACK FOOTER //
// ./src/js/AppDispatcher.js